import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import api from '../utils/api';

export default function RetirementCertificate() {
  const { id } = useParams();
  const [certificate, setCertificate] = useState(null);

  useEffect(() => {
    api.get(`/custody/certificates/${id}`).then((r) => setCertificate(r.data)).catch((error) => {
      toast.error(error.response?.data?.message || 'Failed to load certificate');
    });
  }, [id]);

  if (!certificate) return <div className="loading"><div className="spinner" /></div>;

  return (
    <div className="page-shell page-stack">
      <section className="surface-panel glow-surface" style={{ padding: '1.8rem' }}>
        <div className="section-tag">Retirement certificate</div>
        <h1 className="section-title">{certificate.certificate_code}</h1>
        <p className="section-copy">{certificate.project_name} · {certificate.symbol}</p>
      </section>
      <section className="surface-panel" style={{ padding: '1.5rem' }}>
        <div className="summary-list">
          <div className="summary-row"><span className="label">Quantity</span><span className="value">{Number(certificate.quantity).toLocaleString('en-IN')} tCO2e</span></div>
          <div className="summary-row"><span className="label">Beneficiary</span><span className="value">{certificate.beneficiary_name}</span></div>
          <div className="summary-row"><span className="label">Reason</span><span className="value">{certificate.retirement_reason}</span></div>
          <div className="summary-row"><span className="label">Chain tx</span><span className="value">{certificate.tx_hash}</span></div>
        </div>
      </section>
    </div>
  );
}
